import AdvanceSearchContextProvider from "./AdvanceSearchContext";
import InterviewAdvanceSearch from "./InterviewAdvanceSearch";

export default function InterviewAdvanceSearchPage() {
  return (
    <AdvanceSearchContextProvider>
      <InterviewAdvanceSearch />
    </AdvanceSearchContextProvider>
  );
}
